export const property = {
  createProperty: {
    title: "Unterkunft erstellen",
    of: "von",
  },
  sections: {
    details: "Details der Unterkunft",
    presentation: "Präsentation",
    rooms: "Zimmer",
    bookingSettings: "Buchungseinstellungen",
    checkinSettings: "Check-in-Einstellungen",
    extras: "Zusatzservices",
  },

  menu: {
    name: "Name",
    location: "Standort",
    logo: "Logo der Unterkunft",
    capacity: "Kapazität",
    services: "Services der Unterkunft",
    description: "Beschreibung",

    roomTypes: "Zimmertypen",
    roomManagement: "Zimmer verwalten",

    imagesRooms: "Zimmerbilder",
    imagesProperty: "Bilder der Unterkunft",

    priceCurrency: "Preis & Währung",
    rates: "Tarife",
    maintenance: "Wartung der Unterkunft",

    scheduling: "Zeitplanung",

    sesHospedajes: "SES Hospedajes",

    smartLocks: "Smarte Schlösser",
    experiences: "Erlebnisse & Services",
    chatbot: "KI-ChatBot",
  },

  firstStep: {
    heading: "Wie heißt Ihre Unterkunft?",
    subheading:
      "Gewinnen Sie Gäste mit einem einprägsamen Namen, der das Beste Ihrer Unterkunft hervorhebt.",
    fieldLabel: "Name Ihrer Unterkunft",
    placeholder: "z. B. Paradise Beach",
    internalNameLabel: "Interner Name",
    internalNamePlaceholder: "Interner Referenzname für die Unterkunft",
  },

  locationStep: {
    heading: "Wo befindet sich Ihre Unterkunft?",
    subheading:
      "Geben Sie die genaue Adresse an, damit Gäste Ihre Unterkunft leicht finden.",
    countryLabel: "Land",
    addressLabel: "Vollständige Adresse",
    addressPlaceholder: "z. B. Calle Sierpes 25, Sevilla",
    cityLabel: "Stadt",
    cityPlaceholder: "z. B. Sevilla",
    zipLabel: "Postleitzahl",
    zipPlaceholder: "z. B. 41004",
  },
  logoStep: {
    heading: "Wie sieht das Logo Ihrer Unterkunft aus?",
    description:
      "Fügen Sie das Logo Ihrer Unterkunft hinzu, um professioneller zu wirken und leichter erkennbar zu sein. Erlaubte Formate: PNG, JPG, SVG.",
    currentLogoTitle: "Aktuelles Logo:",
    currentLogoAlt: "Aktuelles Logo",
  },

  roomTypeStep: {
    heading: "Zimmerinformationen",
    description:
      "Geben Sie einen Namen für diesen Zimmertyp ein, z. B. „Doppelzimmer“ oder „Familiensuite“. So erkennen Sie ihn leicht im Kalender und in den Buchungskanälen. Über Ihr Dashboard können Sie weitere Zimmertypen hinzufügen",
    basicInfoTitle: "Grundinformationen",
    nameLabel: "Name",
    namePlaceholder: "Individueller Name",
    occupancyTitle: "Zimmerkapazität",
    adultsLabel: "Erwachsene",
    childrenLabel: "Kinder",
    infantsLabel: "Kleinkinder",
  },

  hotelRoomsStep: {
    heading: "Weisen Sie die physischen Zimmer Ihrer Unterkunft zu",
    description:
      "Erstellen Sie die tatsächlichen Zimmer, die für Buchungen verfügbar sein sollen, z. B. „101 - Doppelzimmer“ oder „302 - Familiensuite“. So organisieren Sie sie im Kalender und verwalten die Verfügbarkeit mühelos.",
    roomTypeLabel: "Zimmertyp",
    roomNameLabel: "Zimmername",
    roomNamePlaceholder: "Individueller Name",
    roomCodeLabel: "Zimmernummer oder Code",
    roomCodePlaceholder: "Optional",
  },

  capacityStep: {
    heading: "Teilen Sie die wichtigsten Details zu Ihrer Unterkunft",
    description:
      "Geben Sie die Anzahl der Gäste, Schlafzimmer und Badezimmer an. Schlafzimmer und Badezimmer gelten standardmäßig als privat. Wenn sie geteilt werden, können Sie das später in den Details der Unterkunft ändern.",
    labels: {
      guests: "Gäste",
      bedrooms: "Schlafzimmer",
      bathrooms: "Badezimmer",
    },
  },

  servicesStep: {
    heading: "Zeigen Sie Gästen, was Ihre Unterkunft bietet",
    subtitle:
      "Wählen Sie die verfügbare Ausstattung aus. Weitere können Sie später im CMS hinzufügen.",
    services: {
      oven: "Backofen & Kochfeld",
      pets_allowed: "Haustiere erlaubt",
      wifi: "WLAN-Internet",
      essentials: "Grundausstattung",
      washing_machine: "Waschmaschine",
      air_conditioning: "Klimaanlage",
      heating: "Zentralheizung",
      parking: "Parkplatz",
      children_allowed: "Kinder erlaubt",
      refrigerator: "Kühlschrank",
    },
  },

  priceStep: {
    heading: "Wie hoch ist der Preis pro Nacht?",
    subtitle:
      "Legen Sie den Standardpreis fest, um den ersten Nachttarif zu erstellen, sowie die Währung Ihrer Unterkunft.",
    labels: {
      pricePerNight: "Preis pro Nacht",
      currency: "Währung",
    },
    placeholders: {
      priceExample: "z. B. 100",
    },
    requiredAsterisk: "*",
  },

  descriptionStep: {
    heading: "Wie würden Sie Ihre Unterkunft beschreiben?",
    subtitle:
      "Gewinnen Sie Gäste mit einer kurzen Beschreibung Ihrer Unterkunft. Heben Sie die vorhandene Ausstattung und nahe gelegene Sehenswürdigkeiten hervor.",
    placeholders: {
      example:
        "z. B. Ein stilvolles Loft mit Stadtblick, perfekt zum Arbeiten, Shoppen und Eintauchen in das urbane Lebensgefühl.",
    },
    inspiration: "Brauchen Sie Inspiration?",
    buttons: {
      useAI: "KI nutzen",
      generating: "Wird erstellt...",
    },
    errors: {
      generate:
        "Beim Erstellen der Beschreibung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    },
  },
  navigation: {
    save: "Speichern",
    next: "Weiter",
  },
  common: {
    success: "Erfolg",
    error: "Fehler",
    cancel: "Abbrechen",
    save: "Speichern",
  },

  images: {
    heading: "Bilder der Unterkunft",
    subtitleHotel:
      "Fügen Sie Ihre Zimmerfotos hinzu, damit sie auf Ihrer Direktbuchungsseite verwendet werden können.",
    subtitleApt:
      "Fügen Sie die Fotos Ihrer Unterkunft hinzu, damit sie auf Ihrer Direktbuchungsseite verwendet werden können.",

    loadRoomsError: "Die Zimmer konnten nicht geladen werden",
    uploadSuccess: "Gültige Bilder erfolgreich hochgeladen",
    uploadErrorGeneric: "Fehler beim Hochladen der Bilder",

    deleteConfirmMessage: "Möchten Sie dieses Bild wirklich löschen?",
    deleteConfirmHeader: "Bestätigung",
    deleteAccept: "Löschen",
    deleteReject: "Abbrechen",
    deleteSuccess: "Bild erfolgreich gelöscht",
    deleteError: "Fehler beim Löschen des Bildes",

    setMainSuccess: "Hauptbild aktualisiert",
    setMainError: "Fehler beim Festlegen des Hauptbildes",

    invalidFilesTitle: "Ungültige Dateien",

    mainBadge: "Hauptbild",
  },

  dropzone: {
    prompt: "Bilder hierher ziehen oder zum Auswählen klicken",
    formatHint: "Formate: JPEG, PNG, GIF.",
    uploading: "Bilder werden hochgeladen... {progress}%",
    invalidHeader: "Einige Dateien erfüllen die Anforderungen nicht:",
    reasonType: "ungültiger Typ",
    reasonSize: "überschreitet die Größenbeschränkung",
    and: "und",
  },

  checkin: {
    heading: "Wann werden die Check-in-Links gesendet?",
    subtitle:
      "Planen Sie den automatischen Versand des Check-in-Links an Ihre Gäste.",

    options: {
      same_day: { amount: "Am selben Tag", text: "des Check-ins" },
      24: { amount: "24 Stunden", text: "vor dem Check-in" },
      48: { amount: "48 Stunden", text: "vor dem Check-in" },
      72: { amount: "72 Stunden", text: "vor dem Check-in" },
      disabled: { amount: "Deaktivieren", text: "Ich sende ihn manuell" },
    },
    recommended: "Empfohlen",

    details: {
      sameDay: "6 Uhr am selben Tag",
      previousNight: "18 Uhr am Vorabend",
      corresponding: "18 Uhr am entsprechenden Tag",
    },

    confirm: {
      message: "Möchten Sie den Check-in-Zeitplan wirklich ändern?",
      header: "Änderung bestätigen",
      accept: "Zeitplan ändern",
      reject: "Abbrechen",
    },

    toasts: {
      loadError: {
        title: "Fehler",
        body: "Die Check-in-Einstellungen konnten nicht geladen werden.",
      },
      saveSuccess: {
        title: "Einstellungen aktualisiert",
        body: "Vorgang erfolgreich abgeschlossen",
      },
    },

    messages: {
      disabled: "Der automatische Versand ist deaktiviert. Der Link muss manuell gesendet werden.",
      same_day: "Check-ins werden um 6 Uhr am Tag des Check-ins gesendet",
      exactly24: "Check-ins werden um 18 Uhr am Abend vor dem Check-in gesendet",
      // If you don't have ICU plural, use a generic message
      daysBefore:
        "Check-ins werden um 18 Uhr gesendet, {days} Tag(e) vor dem Check-in",
    },
  },

  police: {
    header: "Daten der zuständigen Behörde registrieren",
    toasts: {
      saveSuccess: {
        title: "Aktion erfolgreich abgeschlossen",
        body: "Die Behördendaten wurden erfolgreich gespeichert",
      },
    },
    errors: {
      lessorRequired: {
        title: "Fehler, Feld Vermieter",
        body: "Der Vermietercode ist erforderlich",
      },
      establishmentRequired: {
        title: "Fehler, Feld Betrieb",
        body: "Der Betriebscode ist erforderlich",
      },
    },
  },

  identity: {
    title: "Check-in-Shop",
    subtitle: "Beim Einchecken erhält der Gast per WhatsApp einen Link mit allem, was er zum Aufenthalt hinzufügen kann.",
    propertyLabel: "Unterkunft:",
    toggle: {
      title: "Identitätsprüfung aktivieren",
      hint: "Wenn aktiviert, müssen Gäste ihre Identität bestätigen.",
      on: "AN",
      off: "AUS",
    },
    toasts: {
      updated: "Einstellungen der Identitätsprüfung erfolgreich aktualisiert",
      updateError: "Fehler beim Aktualisieren der Einstellungen der Identitätsprüfung",
    },
  },

  guestReviews: {
    subtitle:
      "Geben Sie die URL der Bewertungsseite ein, die Sie einrichten möchten, damit Ihre Gäste dort ihre Bewertung abgeben können, ob bei Google oder auf einer anderen Bewertungsseite, die Sie nutzen. Das verbessert die Sichtbarkeit und den Ruf der Unterkunft.",
    enableTitle: "Gästebewertungen aktivieren",
  },

  smartLocks: {
    title: "Smarte Schlösser",
    subtitle:
      "Verbinden Sie kompatible smarte Schlösser und vergessen Sie physische Schlüssel. Zugangscodes werden automatisch erzeugt und versendet, ohne manuellen Aufwand und zu 100 % sicher.",
    propertyLabel: "Unterkunft",
    compatibleTitle: "Kompatible smarte Schlösser",
    andManyMore: "und viele mehr...",

    enableTitle: "Smartes Schloss aktivieren",
    enableHelp:
      "Senden Sie Ihren Gästen den Zugangscode, sobald der Check-in abgeschlossen ist, genau zur gewählten Check-in-Zeit.",

    configTitle: "Konfiguration",
    configSubtitle: "Legen Sie fest, wie der Zugangscode zugestellt wird",

    deliveryLabel: "Uhrzeit für den Versand des Zugangscodes",
    deliveryDesc:
      "Wählen Sie die Uhrzeit, zu der der Zugangscode am Tag der Buchung an Ihren Gast gesendet wird.",
    saveTimeBtn: "Uhrzeit speichern",
    saveTimeLoading: "Wird gespeichert...",

    accessTypeLabel: "Art des Zugangscodes",

    static: {
      title: "Statischer Code",
      desc: "Denselben Code für alle Gäste verwenden",
    },
    dynamic: {
      title: "Dynamischer Code",
      desc: "Eindeutige Codes pro Buchung erzeugen",
      soon: "Demnächst",
    },

    masterCodeLabel: "Master-Zugangscode",
    masterCodePlaceholder: "Geben Sie Ihren Master-Zugangscode ein",
    saveCodeBtn: "Code speichern",
    saveCodeLoading: "Wird gespeichert...",

    masterCodeHelp:
      "Dieser Code wird am Check-in-Tag automatisch zur angegebenen Uhrzeit an die Gäste gesendet.",

    dynamicInfo: {
      title: "Dynamische Zugangscodes",
      desc: "Diese Premium-Funktion erzeugt automatisch eindeutige Zugangscodes für jede Buchung, für mehr Sicherheit und ein besseres Gasterlebnis. Bald verfügbar!",
    },

    support: {
      title: "Brauchen Sie Hilfe bei der Integration?",
      desc: "Wir integrieren alle großen Marken smarter Schlösser. Unser technisches Team hilft Ihnen bei der Konfiguration Ihres Modells.",
      cta: "Support kontaktieren",
    },

    errors: {
      emptyKey: "Bitte geben Sie einen Zugangscode ein",
    },

    toasts: {
      updateSuccess: "Einstellungen für smarte Schlösser erfolgreich aktualisiert",
      updateError: "Fehler beim Aktualisieren der Einstellungen für smarte Schlösser",
      timeSuccess: "Versandzeit erfolgreich aktualisiert",
      timeError: "Fehler beim Aktualisieren der Versandzeit",
      keySuccess: "Zugangscode erfolgreich gespeichert",
      keyError: "Fehler beim Speichern des Zugangscodes",
    },
  },

  services: {
    listMovedHelp: "Die Serviceliste gilt fürs ganze Konto: einmal anlegen und ankreuzen, in welchen Inseraten sie angeboten wird.",
    listMovedLink: "Zu Services und Erlebnisse",
    title: "Erlebnisse und Services",
    subtitle: "Verwalten Sie die Zusatzservices Ihrer Unterkunft.",
    enableTitle: "Shop für Erlebnisse und Services aktivieren",
    enableHelp:
      "Bewerben Sie alle zusätzlichen Erlebnisse und Services Ihrer Unterkunft. Gäste erhalten beim Check-in einen WhatsApp-Link.",
    storeType: {
      title: "Shop-Typ",
      internal: {
        title: "Interner Shop",
        desc: "Verwalten Sie Ihre Services direkt auf der Plattform",
      },
      external: {
        title: "Externer Shop",
        desc: "Leiten Sie Gäste zu Ihrem externen Shop weiter",
      },
    },
    externalConfig: {
      title: "Konfiguration des externen Shops",
      guestMessageLabel: "Nachricht für Gäste",
      guestMessagePlaceholder:
        "Z. B.: Entdecken Sie unsere Zusatzservices und einzigartigen Erlebnisse in unserem Online-Shop...",
      guestMessageHelp:
        "Nachricht, die Gästen nach dem Check-in angezeigt wird (max. 200 Zeichen)",
      urlLabel: "URL Ihres externen Shops",
      urlPlaceholder: "https://ihr-externer-shop.de",
      urlHelp: "Vollständige URL, unter der Gäste Erlebnisse und Services buchen können",
      noteTitle: "Hinweis:",
      noteText:
        "Gäste erhalten diese personalisierte Nachricht mit dem Link, nachdem sie den Check-in abgeschlossen haben.",
    },
    addBtn: "Hinzufügen",
    delete: {
      title: "Service löschen?",
      text: "Diese Aktion kann nicht rückgängig gemacht werden",
      confirm: "Löschen",
      cancel: "Abbrechen",
    },
    toasts: {
      stateUpdated: "Status des Services aktualisiert",
      deleted: "Service erfolgreich gelöscht",
      storeUpdated: "Einstellungen für Erlebnisse und Services erfolgreich aktualisiert",
      storeError: "Fehler beim Aktualisieren der Einstellungen für Erlebnisse und Services",
      configUpdated: "Shop-Konfiguration erfolgreich aktualisiert",
      configError: "Fehler beim Aktualisieren der Shop-Konfiguration",
    },
  },
  bot: {
    enableTitle: "Virtuellen Assistenten aktivieren",
    enableHelp: "Automatisieren Sie den Gästesupport mit schnellen Antworten auf WhatsApp.",
  },

  rooms: {
    heading: "Zimmertypen",
    subtitle: "Verwalten Sie die Zimmertypen Ihrer Unterkunft.",
    addTypeCta: "Zimmertyp hinzufügen",
    adultsCapacity: "Kapazität Erwachsene: {count}",
    emptyList: "Keine Zimmer registriert.",

    deleteConfirmHeader: "Löschen bestätigen",
    deleteConfirmMessage:
      "Möchten Sie dieses Zimmer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteConfirmAccept: "Ja, löschen",
    deleteConfirmReject: "Abbrechen",

    deleteSuccess: "Zimmer erfolgreich gelöscht.",
    deleteError: "Fehler beim Löschen des Zimmers.",
  },

  roomMgmt: {
    remaining: "Verfügbar: {count}",
    heading: "Zimmer verwalten",
    subtitle: "Weisen Sie den registrierten Typen einzelne Zimmer zu.",
    totalRooms: "Zimmer gesamt: {count}",

    typeLabel: "Typ",
    codeLabel: "Code",
    nameLabel: "Name",
    descLabel: "Beschreibung",

    selectPlaceholder: "Auswählen",
    codePlaceholder: "Code",
    namePlaceholder: "Zimmername",
    descPlaceholder: "Zimmerbeschreibung",

    addBtn: "Hinzufügen",

    planLimitTitle: "Limit erreicht",
    planLimitMsg:
      "Sie haben die maximale Anzahl an Zimmern erreicht, die Ihr Tarif erlaubt. Bitte erweitern Sie Ihr Abonnement, um weitere hinzuzufügen.",

    loadTypesError: "Die Zimmertypen konnten nicht geladen werden",
    loadRoomsError: "Die vorhandenen Zimmer konnten nicht geladen werden",

    saveSuccessTitle: "Erfolg",
    saveSuccessMsg: "Zimmer erfolgreich gespeichert",
    saveError: "Die Zimmer konnten nicht gespeichert werden",

    deleteSuccess: "Zimmer erfolgreich gelöscht.",
    deleteError: "Fehler beim Löschen des Zimmers.",
    formIncompleteError:
      "Bitte geben Sie für alle Zimmer den Zimmertyp und den Namen an.",
  },

  rates: {
    heading: "Tarife",
    subtitleHotel: "Verwalten Sie die Tarife Ihrer Unterkünfte.",
    subtitleSingle: "Verwalten Sie die Tarife Ihrer Unterkunft.",
    adultsCapacity: "Kapazität Erwachsene: {count}",
    roomsCount: "Zimmer {count}",
    singleUnit: "Unterkunftseinheit",

    table: {
      name: "Name",
      occupancy: "Gäste",
      priceTaxIncl: "Preis (INKL. STEUER)",
      actions: "Aktionen",
    },

    addRate: "Tarif hinzufügen",
    emptyList: "Keine Tarife registriert.",

    deleteConfirmHeader: "Löschen bestätigen",
    deleteConfirmMessage:
      "Möchten Sie diesen Tarif wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteConfirmAccept: "Ja, löschen",
    deleteConfirmReject: "Abbrechen",

    deleteSuccess: "Tarif erfolgreich gelöscht.",
    deleteError: "Fehler beim Löschen des Tarifs.",
  },
};

export default property;
